import { render, staticRenderFns } from "./OrderDetailsPage.vue?vue&type=template&id=f9da1426&scoped=true"
import script from "./OrderDetailsPage.vue?vue&type=script&lang=js"
export * from "./OrderDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsPage.vue?vue&type=style&index=0&id=f9da1426&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9da1426",
  null
  
)

export default component.exports